export default "__VITE_ASSET__CCmuMfS___"